const Link = ({ isActive = true }) => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.601562"
                width="25.6"
                height="25.6"
                rx="4.8"
                fill={isActive ? '#FDEACA' : 'transparent'}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.9734 8.73716C16.8031 7.56678 14.9055 7.56678 13.7351 8.73716L12.0419 10.4304C10.8674 11.6049 10.8707 13.5101 12.0493 14.6805L12.3207 14.9499C12.5558 15.1834 12.9357 15.1821 13.1692 14.947C13.4027 14.7118 13.4014 14.3319 13.1662 14.0984L12.8949 13.829C12.1877 13.1268 12.1857 11.9836 12.8904 11.279L14.5837 9.58568C15.2854 8.88394 16.4232 8.88394 17.1249 9.58568C17.8279 10.2887 17.8265 11.429 17.1217 12.1302L16.2801 12.9675C16.0452 13.2012 16.0442 13.5811 16.2779 13.816C16.5116 14.0509 16.8915 14.0519 17.1264 13.8182L17.968 12.9809C19.1435 11.8114 19.1459 9.90965 17.9734 8.73716ZM8.64235 18.0731C9.81392 19.2447 11.7134 19.2447 12.885 18.0731L14.582 16.3761C15.7536 15.2045 15.7536 13.305 14.582 12.1334L14.2924 11.8438C14.0581 11.6095 13.6782 11.6095 13.4439 11.8438C13.2096 12.0782 13.2096 12.4581 13.4439 12.6924L13.7335 12.982C14.4365 13.6849 14.4365 14.8246 13.7335 15.5276L12.0365 17.2246C11.3335 17.9276 10.1938 17.9276 9.49088 17.2246C8.78794 16.5217 8.78794 15.382 9.49088 14.679L10.3461 13.8239C10.5804 13.5895 10.5804 13.2096 10.3461 12.9753C10.1117 12.741 9.73184 12.741 9.49753 12.9753L8.64235 13.8305C7.47078 15.0021 7.47078 16.9016 8.64235 18.0731Z"
                fill={isActive ? '#FFA000' : '#616161'}
            />
        </svg>
    )
}

export default Link
